import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationTofuWorkspaceUnlockAllArgs,
  TofuWorkspace,
  TofuWorkspaceUnlockAllResponse,
} from "types/generated";

type UnlockAllTofuWorkspacesData = {
  tofuWorkspaceUnlockAll: Pick<TofuWorkspaceUnlockAllResponse, "unlockedWorkspaces"> & {
    unlockedWorkspaces: Array<Pick<TofuWorkspace, "id" | "name" | "isLocked">>;
  };
};

export const TOFU_WORKSPACE_UNLOCK_ALL: TypedDocumentNode<
  UnlockAllTofuWorkspacesData,
  MutationTofuWorkspaceUnlockAllArgs
> = gql`
  mutation TofuWorkspaceUnlockAll($stack: ID!) {
    tofuWorkspaceUnlockAll(stack: $stack) {
      unlockedWorkspaces {
        id
        name
        isLocked
      }
    }
  }
`;
